import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["__demoMode"],
  _excluded2 = ["id"],
  _excluded3 = ["id"],
  _excluded4 = ["id", "focus"];
var _Ge;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import C, { createContext as Q, createRef as de, useContext as Z, useEffect as ee, useMemo as h, useReducer as ge, useRef as J, useState as ce } from "react";
import { useNestedPortals as Se } from '../../components/portal/portal.js';
import { useEvent as R } from '../../hooks/use-event.js';
import { useEventListener as Re } from '../../hooks/use-event-listener.js';
import { useId as K } from '../../hooks/use-id.js';
import { useIsoMorphicEffect as Ae } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as ve } from '../../hooks/use-latest-value.js';
import { useOutsideClick as Oe } from '../../hooks/use-outside-click.js';
import { useOwnerDocument as ne } from '../../hooks/use-owner.js';
import { useResolveButtonType as Ce } from '../../hooks/use-resolve-button-type.js';
import { useMainTreeNode as Me, useRootContainers as xe } from '../../hooks/use-root-containers.js';
import { optionalRef as Fe, useSyncRefs as j } from '../../hooks/use-sync-refs.js';
import { Direction as H, useTabDirection as Te } from '../../hooks/use-tab-direction.js';
import { Features as le, Hidden as ae } from '../../internal/hidden.js';
import { OpenClosedProvider as Ie, State as V, useOpenClosed as me } from '../../internal/open-closed.js';
import { isDisabledReactIssue7711 as ye } from '../../utils/bugs.js';
import { Focus as G, FocusableMode as _e, focusIn as N, FocusResult as pe, getFocusableElements as se, isFocusableElement as Le } from '../../utils/focus-management.js';
import { match as k } from '../../utils/match.js';
import '../../utils/micro-task.js';
import { getOwnerDocument as Be } from '../../utils/owner.js';
import { Features as te, forwardRefWithAs as X, render as Y, useMergeRefsFn as De } from '../../utils/render.js';
import { Keys as w } from '../keyboard.js';
var he = function (u) {
    return u[u.Open = 0] = "Open", u[u.Closed = 1] = "Closed", u;
  }(he || {}),
  He = function (e) {
    return e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e;
  }(He || {});
var Ge = (_Ge = {}, _defineProperty(_Ge, 0, function _(t) {
    var _k;
    var o = _objectSpread(_objectSpread({}, t), {}, {
      popoverState: k(t.popoverState, (_k = {}, _defineProperty(_k, 0, 1), _defineProperty(_k, 1, 0), _k))
    });
    return o.popoverState === 0 && (o.__demoMode = !1), o;
  }), _defineProperty(_Ge, 1, function _(t) {
    return t.popoverState === 1 ? t : _objectSpread(_objectSpread({}, t), {}, {
      popoverState: 1
    });
  }), _defineProperty(_Ge, 2, function _(t, o) {
    return t.button === o.button ? t : _objectSpread(_objectSpread({}, t), {}, {
      button: o.button
    });
  }), _defineProperty(_Ge, 3, function _(t, o) {
    return t.buttonId === o.buttonId ? t : _objectSpread(_objectSpread({}, t), {}, {
      buttonId: o.buttonId
    });
  }), _defineProperty(_Ge, 4, function _(t, o) {
    return t.panel === o.panel ? t : _objectSpread(_objectSpread({}, t), {}, {
      panel: o.panel
    });
  }), _defineProperty(_Ge, 5, function _(t, o) {
    return t.panelId === o.panelId ? t : _objectSpread(_objectSpread({}, t), {}, {
      panelId: o.panelId
    });
  }), _Ge),
  ue = Q(null);
ue.displayName = "PopoverContext";
function oe(t) {
  var o = Z(ue);
  if (o === null) {
    var u = new Error("<".concat(t, " /> is missing a parent <Popover /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(u, oe), u;
  }
  return o;
}
var ie = Q(null);
ie.displayName = "PopoverAPIContext";
function fe(t) {
  var o = Z(ie);
  if (o === null) {
    var u = new Error("<".concat(t, " /> is missing a parent <Popover /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(u, fe), u;
  }
  return o;
}
var Pe = Q(null);
Pe.displayName = "PopoverGroupContext";
function Ee() {
  return Z(Pe);
}
var re = Q(null);
re.displayName = "PopoverPanelContext";
function Ne() {
  return Z(re);
}
function ke(t, o) {
  return k(o.type, Ge, t, o);
}
var we = "div";
function Ue(t, o) {
  var _k2;
  var B;
  var _t$__demoMode = t.__demoMode,
    u = _t$__demoMode === void 0 ? !1 : _t$__demoMode,
    M = _objectWithoutProperties(t, _excluded),
    x = J(null),
    n = j(o, Fe(function (l) {
      x.current = l;
    })),
    e = J([]),
    c = ge(ke, {
      __demoMode: u,
      popoverState: u ? 0 : 1,
      buttons: e,
      button: null,
      buttonId: null,
      panel: null,
      panelId: null,
      beforePanelSentinel: de(),
      afterPanelSentinel: de()
    }),
    _c = _slicedToArray(c, 2),
    _c$ = _c[0],
    f = _c$.popoverState,
    s = _c$.button,
    I = _c$.buttonId,
    a = _c$.panel,
    v = _c$.panelId,
    y = _c$.beforePanelSentinel,
    A = _c$.afterPanelSentinel,
    P = _c[1],
    p = ne((B = x.current) != null ? B : s),
    E = h(function () {
      if (!s || !a) return !1;
      var _iterator = _createForOfIteratorHelper(document.querySelectorAll("body > *")),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var W = _step.value;
          if (Number(W == null ? void 0 : W.contains(s)) ^ Number(W == null ? void 0 : W.contains(a))) return !0;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var l = se(),
        S = l.indexOf(s),
        q = (S + l.length - 1) % l.length,
        U = (S + 1) % l.length,
        z = l[q],
        be = l[U];
      return !a.contains(z) && !a.contains(be);
    }, [s, a]),
    F = ve(I),
    D = ve(v),
    _ = h(function () {
      return {
        buttonId: F,
        panelId: D,
        close: function close() {
          return P({
            type: 1
          });
        }
      };
    }, [F, D, P]),
    O = Ee(),
    L = O == null ? void 0 : O.registerPopover,
    $ = R(function () {
      var l;
      return (l = O == null ? void 0 : O.isFocusWithinPopoverGroup()) != null ? l : (p == null ? void 0 : p.activeElement) && ((s == null ? void 0 : s.contains(p.activeElement)) || (a == null ? void 0 : a.contains(p.activeElement)));
    });
  ee(function () {
    return L == null ? void 0 : L(_);
  }, [L, _]);
  var _Se = Se(),
    _Se2 = _slicedToArray(_Se, 2),
    i = _Se2[0],
    b = _Se2[1],
    T = xe({
      mainTreeNodeRef: O == null ? void 0 : O.mainTreeNodeRef,
      portals: i,
      defaultContainers: [s, a]
    });
  Re(p == null ? void 0 : p.defaultView, "focus", function (l) {
    var S, q, U, z;
    l.target !== window && l.target instanceof HTMLElement && f === 0 && ($() || s && a && (T.contains(l.target) || (q = (S = y.current) == null ? void 0 : S.contains) != null && q.call(S, l.target) || (z = (U = A.current) == null ? void 0 : U.contains) != null && z.call(U, l.target) || P({
      type: 1
    })));
  }, !0), Oe(T.resolveContainers, function (l, S) {
    P({
      type: 1
    }), Le(S, _e.Loose) || (l.preventDefault(), s == null || s.focus());
  }, f === 0);
  var d = R(function (l) {
      P({
        type: 1
      });
      var S = function () {
        return l ? l instanceof HTMLElement ? l : "current" in l && l.current instanceof HTMLElement ? l.current : s : s;
      }();
      S == null || S.focus();
    }),
    r = h(function () {
      return {
        close: d,
        isPortalled: E
      };
    }, [d, E]),
    m = h(function () {
      return {
        open: f === 0,
        close: d
      };
    }, [f, d]),
    g = {
      ref: n
    };
  return C.createElement(re.Provider, {
    value: null
  }, C.createElement(ue.Provider, {
    value: c
  }, C.createElement(ie.Provider, {
    value: r
  }, C.createElement(Ie, {
    value: k(f, (_k2 = {}, _defineProperty(_k2, 0, V.Open), _defineProperty(_k2, 1, V.Closed), _k2))
  }, C.createElement(b, null, Y({
    ourProps: g,
    theirProps: M,
    slot: m,
    defaultTag: we,
    name: "Popover"
  }), C.createElement(T.MainTreeNode, null))))));
}
var We = "button";
function Ke(t, o) {
  var u = K(),
    _t$id = t.id,
    M = _t$id === void 0 ? "headlessui-popover-button-".concat(u) : _t$id,
    x = _objectWithoutProperties(t, _excluded2),
    _oe = oe("Popover.Button"),
    _oe2 = _slicedToArray(_oe, 2),
    n = _oe2[0],
    e = _oe2[1],
    _fe = fe("Popover.Button"),
    c = _fe.isPortalled,
    f = J(null),
    s = "headlessui-focus-sentinel-".concat(K()),
    I = Ee(),
    a = I == null ? void 0 : I.closeOthers,
    y = Ne() !== null;
  ee(function () {
    if (!y) return e({
      type: 3,
      buttonId: M
    }), function () {
      e({
        type: 3,
        buttonId: null
      });
    };
  }, [y, M, e]);
  var _ce = ce(function () {
      return Symbol();
    }),
    _ce2 = _slicedToArray(_ce, 1),
    A = _ce2[0],
    P = j(f, o, y ? null : function (r) {
      if (r) n.buttons.current.push(A);else {
        var m = n.buttons.current.indexOf(A);
        m !== -1 && n.buttons.current.splice(m, 1);
      }
      n.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), r && e({
        type: 2,
        button: r
      });
    }),
    p = j(f, o),
    E = ne(f),
    F = R(function (r) {
      var m, g, B;
      if (y) {
        if (n.popoverState === 1) return;
        switch (r.key) {
          case w.Space:
          case w.Enter:
            r.preventDefault(), (g = (m = r.target).click) == null || g.call(m), e({
              type: 1
            }), (B = n.button) == null || B.focus();
            break;
        }
      } else switch (r.key) {
        case w.Space:
        case w.Enter:
          r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (a == null || a(n.buttonId)), e({
            type: 0
          });
          break;
        case w.Escape:
          if (n.popoverState !== 0) return a == null ? void 0 : a(n.buttonId);
          if (!f.current || E != null && E.activeElement && !f.current.contains(E.activeElement)) return;
          r.preventDefault(), r.stopPropagation(), e({
            type: 1
          });
          break;
      }
    }),
    D = R(function (r) {
      y || r.key === w.Space && r.preventDefault();
    }),
    _ = R(function (r) {
      var m, g;
      ye(r.currentTarget) || t.disabled || (y ? (e({
        type: 1
      }), (m = n.button) == null || m.focus()) : (r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (a == null || a(n.buttonId)), e({
        type: 0
      }), (g = n.button) == null || g.focus()));
    }),
    O = R(function (r) {
      r.preventDefault(), r.stopPropagation();
    }),
    L = n.popoverState === 0,
    $ = h(function () {
      return {
        open: L
      };
    }, [L]),
    i = Ce(t, f),
    b = y ? {
      ref: p,
      type: i,
      onKeyDown: F,
      onClick: _
    } : {
      ref: P,
      id: n.buttonId,
      type: i,
      "aria-expanded": n.popoverState === 0,
      "aria-controls": n.panel ? n.panelId : void 0,
      onKeyDown: F,
      onKeyUp: D,
      onClick: _,
      onMouseDown: O
    },
    T = Te(),
    d = R(function () {
      var r = n.panel;
      if (!r) return;
      function m() {
        var _k3, _k4;
        k(T.current, (_k3 = {}, _defineProperty(_k3, H.Forwards, function () {
          return N(r, G.First);
        }), _defineProperty(_k3, H.Backwards, function () {
          return N(r, G.Last);
        }), _k3)) === pe.Error && N(se().filter(function (B) {
          return B.dataset.headlessuiFocusGuard !== "true";
        }), k(T.current, (_k4 = {}, _defineProperty(_k4, H.Forwards, G.Next), _defineProperty(_k4, H.Backwards, G.Previous), _k4)), {
          relativeTo: n.button
        });
      }
      m();
    });
  return C.createElement(C.Fragment, null, Y({
    ourProps: b,
    theirProps: x,
    slot: $,
    defaultTag: We,
    name: "Popover.Button"
  }), L && !y && c && C.createElement(ae, {
    id: s,
    features: le.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: d
  }));
}
var je = "div",
  Ve = te.RenderStrategy | te.Static;
function $e(t, o) {
  var u = K(),
    _t$id2 = t.id,
    M = _t$id2 === void 0 ? "headlessui-popover-overlay-".concat(u) : _t$id2,
    x = _objectWithoutProperties(t, _excluded3),
    _oe3 = oe("Popover.Overlay"),
    _oe4 = _slicedToArray(_oe3, 2),
    n = _oe4[0].popoverState,
    e = _oe4[1],
    c = j(o),
    f = me(),
    s = function () {
      return f !== null ? (f & V.Open) === V.Open : n === 0;
    }(),
    I = R(function (y) {
      if (ye(y.currentTarget)) return y.preventDefault();
      e({
        type: 1
      });
    }),
    a = h(function () {
      return {
        open: n === 0
      };
    }, [n]);
  return Y({
    ourProps: {
      ref: c,
      id: M,
      "aria-hidden": !0,
      onClick: I
    },
    theirProps: x,
    slot: a,
    defaultTag: je,
    features: Ve,
    visible: s,
    name: "Popover.Overlay"
  });
}
var Je = "div",
  Xe = te.RenderStrategy | te.Static;
function Ye(t, o) {
  var u = K(),
    _t$id3 = t.id,
    M = _t$id3 === void 0 ? "headlessui-popover-panel-".concat(u) : _t$id3,
    _t$focus = t.focus,
    x = _t$focus === void 0 ? !1 : _t$focus,
    n = _objectWithoutProperties(t, _excluded4),
    _oe5 = oe("Popover.Panel"),
    _oe6 = _slicedToArray(_oe5, 2),
    e = _oe6[0],
    c = _oe6[1],
    _fe2 = fe("Popover.Panel"),
    f = _fe2.close,
    s = _fe2.isPortalled,
    I = "headlessui-focus-sentinel-before-".concat(K()),
    a = "headlessui-focus-sentinel-after-".concat(K()),
    v = J(null),
    y = j(v, o, function (i) {
      c({
        type: 4,
        panel: i
      });
    }),
    A = ne(v),
    P = De();
  Ae(function () {
    return c({
      type: 5,
      panelId: M
    }), function () {
      c({
        type: 5,
        panelId: null
      });
    };
  }, [M, c]);
  var p = me(),
    E = function () {
      return p !== null ? (p & V.Open) === V.Open : e.popoverState === 0;
    }(),
    F = R(function (i) {
      var b;
      switch (i.key) {
        case w.Escape:
          if (e.popoverState !== 0 || !v.current || A != null && A.activeElement && !v.current.contains(A.activeElement)) return;
          i.preventDefault(), i.stopPropagation(), c({
            type: 1
          }), (b = e.button) == null || b.focus();
          break;
      }
    });
  ee(function () {
    var i;
    t.static || e.popoverState === 1 && ((i = t.unmount) == null || i) && c({
      type: 4,
      panel: null
    });
  }, [e.popoverState, t.unmount, t.static, c]), ee(function () {
    if (e.__demoMode || !x || e.popoverState !== 0 || !v.current) return;
    var i = A == null ? void 0 : A.activeElement;
    v.current.contains(i) || N(v.current, G.First);
  }, [e.__demoMode, x, v, e.popoverState]);
  var D = h(function () {
      return {
        open: e.popoverState === 0,
        close: f
      };
    }, [e, f]),
    _ = {
      ref: y,
      id: M,
      onKeyDown: F,
      onBlur: x && e.popoverState === 0 ? function (i) {
        var T, d, r, m, g;
        var b = i.relatedTarget;
        b && v.current && ((T = v.current) != null && T.contains(b) || (c({
          type: 1
        }), ((r = (d = e.beforePanelSentinel.current) == null ? void 0 : d.contains) != null && r.call(d, b) || (g = (m = e.afterPanelSentinel.current) == null ? void 0 : m.contains) != null && g.call(m, b)) && b.focus({
          preventScroll: !0
        })));
      } : void 0,
      tabIndex: -1
    },
    O = Te(),
    L = R(function () {
      var i = v.current;
      if (!i) return;
      function b() {
        var _k5;
        k(O.current, (_k5 = {}, _defineProperty(_k5, H.Forwards, function () {
          var d;
          N(i, G.First) === pe.Error && ((d = e.afterPanelSentinel.current) == null || d.focus());
        }), _defineProperty(_k5, H.Backwards, function () {
          var T;
          (T = e.button) == null || T.focus({
            preventScroll: !0
          });
        }), _k5));
      }
      b();
    }),
    $ = R(function () {
      var i = v.current;
      if (!i) return;
      function b() {
        var _k6;
        k(O.current, (_k6 = {}, _defineProperty(_k6, H.Forwards, function () {
          var B;
          if (!e.button) return;
          var T = se(),
            d = T.indexOf(e.button),
            r = T.slice(0, d + 1),
            g = [].concat(_toConsumableArray(T.slice(d + 1)), _toConsumableArray(r));
          var _iterator2 = _createForOfIteratorHelper(g.slice()),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var l = _step2.value;
              if (l.dataset.headlessuiFocusGuard === "true" || (B = e.panel) != null && B.contains(l)) {
                var S = g.indexOf(l);
                S !== -1 && g.splice(S, 1);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          N(g, G.First, {
            sorted: !1
          });
        }), _defineProperty(_k6, H.Backwards, function () {
          var d;
          N(i, G.Previous) === pe.Error && ((d = e.button) == null || d.focus());
        }), _k6));
      }
      b();
    });
  return C.createElement(re.Provider, {
    value: M
  }, E && s && C.createElement(ae, {
    id: I,
    ref: e.beforePanelSentinel,
    features: le.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: L
  }), Y({
    mergeRefs: P,
    ourProps: _,
    theirProps: n,
    slot: D,
    defaultTag: Je,
    features: Xe,
    visible: E,
    name: "Popover.Panel"
  }), E && s && C.createElement(ae, {
    id: a,
    ref: e.afterPanelSentinel,
    features: le.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: $
  }));
}
var qe = "div";
function ze(t, o) {
  var u = J(null),
    M = j(u, o),
    _ce3 = ce([]),
    _ce4 = _slicedToArray(_ce3, 2),
    x = _ce4[0],
    n = _ce4[1],
    e = Me(),
    c = R(function (P) {
      n(function (p) {
        var E = p.indexOf(P);
        if (E !== -1) {
          var F = p.slice();
          return F.splice(E, 1), F;
        }
        return p;
      });
    }),
    f = R(function (P) {
      return n(function (p) {
        return [].concat(_toConsumableArray(p), [P]);
      }), function () {
        return c(P);
      };
    }),
    s = R(function () {
      var E;
      var P = Be(u);
      if (!P) return !1;
      var p = P.activeElement;
      return (E = u.current) != null && E.contains(p) ? !0 : x.some(function (F) {
        var D, _;
        return ((D = P.getElementById(F.buttonId.current)) == null ? void 0 : D.contains(p)) || ((_ = P.getElementById(F.panelId.current)) == null ? void 0 : _.contains(p));
      });
    }),
    I = R(function (P) {
      var _iterator3 = _createForOfIteratorHelper(x),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var p = _step3.value;
          p.buttonId.current !== P && p.close();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }),
    a = h(function () {
      return {
        registerPopover: f,
        unregisterPopover: c,
        isFocusWithinPopoverGroup: s,
        closeOthers: I,
        mainTreeNodeRef: e.mainTreeNodeRef
      };
    }, [f, c, s, I, e.mainTreeNodeRef]),
    v = h(function () {
      return {};
    }, []),
    y = t,
    A = {
      ref: M
    };
  return C.createElement(Pe.Provider, {
    value: a
  }, Y({
    ourProps: A,
    theirProps: y,
    slot: v,
    defaultTag: qe,
    name: "Popover.Group"
  }), C.createElement(e.MainTreeNode, null));
}
var Qe = X(Ue),
  Ze = X(Ke),
  et = X($e),
  tt = X(Ye),
  ot = X(ze),
  Ct = Object.assign(Qe, {
    Button: Ze,
    Overlay: et,
    Panel: tt,
    Group: ot
  });
export { Ct as Popover };